import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import { selectIsAuthenticated } from '@/store/selectors/authSelectors';
import { selectShowUserIsPepOrHioLogout } from '@/store/modal/selectors';
import { setShowUserIsPepOrHioLogout } from '@/store/modal/actions';
import { openDrawer } from '@/store/ui/actions';
import { DrawerName } from '@/store/ui/reducers';
import { useModal } from '@/features/modal/useModal';
import { MODALS } from '@/features/modal/types';

export function usePepHioHook() {
  const showuserIsPepOrHioLogout = useSelector(selectShowUserIsPepOrHioLogout);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const dispatch = useDispatch();
  const intl = useIntl();
  const { openModal } = useModal();

  useEffect(() => {
    if (!isAuthenticated && showuserIsPepOrHioLogout) {
      openModal(MODALS.BASIC, {
        title: intl.formatMessage({ id: 'detailsReverification.userBlock.title' }),
        body: intl.formatMessage({ id: 'detailsReverification.userBlock.text' }),
        btnText: intl.formatMessage({ id: 'detailsReverification.userBlock.cta' }),
        onBtnClick: () => {
          dispatch(setShowUserIsPepOrHioLogout(false));
          dispatch(openDrawer(DrawerName.Help));
        },
        onClose: () => {
          dispatch(setShowUserIsPepOrHioLogout(false));
        },
      });
    }
  }, [showuserIsPepOrHioLogout, isAuthenticated]);
}
